<!-- Componente unificado que gerencia todos os status -->
@if (data) {
  <app-detail-status-monitoring [data]="data"></app-detail-status-monitoring>
}

@if (data) {
  <!-- Lista de validações de monitoramento -->
  <mat-tab-group>
    <mat-tab label="Validação dados de entrada">
      @for (v of data.fileValidations; track v.id; let i = $index) {
        <app-detail-monitoring-validation
          [validation]="v"
        ></app-detail-monitoring-validation>
        <hr />
      }
    </mat-tab>
    @if (data.monitoringAreas && data.monitoringAreas.length > 0) {
      <mat-tab label="Áreas de monitoramento aprovadas">
        <div class="monitoring-areas-container">
          <app-monitoring-areas-table
            [dataSource]="areasDataSource"
            [length]="areasLength"
            [isLoading]="areasIsLoading"
            [config]="areasTableConfig"
            (pageChange)="onAreasPageChange($event)"
            (sortChange)="onAreasSort($event)"
            (searchChange)="onAreasSearch($event)"
          ></app-monitoring-areas-table>
        </div>
      </mat-tab>
    }
  </mat-tab-group>

  <div class="buttons-footer">
    @if (canApproveOrReject) {
      <button (click)="reject()" mat-stroked-button>
        Rejeitar arquivo
        <mat-icon>arrow_back</mat-icon>
      </button>
    }
    @if (canApproveOrReject) {
      <button (click)="approve()" mat-flat-button>
        Aprovar Área de Monitoramento
        <mat-icon>save</mat-icon>
      </button>
    }
  </div>
}
